<div class="formModal" style="z-index: 105001 !important">
  <button class="d-flex justify-content-center" mat-raised-button color="warn" style="width: 20px; min-width: 20px; height: 36px; float: right" (click)="hideShippingModal()">&#10005;</button>
  <form [formGroup]="shippingForm">
    <div class="row mt-5">
      <!-- Only show these fields when NOT from "Add Shipping" -->
      <div class="col-4 mt-2 mb-5" *ngIf="!isFromAddMedia">
        <div class="input-group">
          <div class="form-group w-100">
            <select class="form-control modal-text-box" formControlName="assetId">
              <option [ngValue]="">{{ "Select Asset" | translate }}</option>
              <option *ngFor="let asset of assetDropdownList" [value]="asset.id">
                {{ asset.description | translate }}
              </option>
            </select>
            <label class="label-control">{{ "Select Asset" | translate }}</label>
          </div>
        </div>
      </div>

      <div class="col-4 mt-2 mb-5" *ngIf="!isFromAddMedia">
        <div class="input-group">
          <div class="form-group w-100">
            <select class="form-control modal-text-box" formControlName="media" [attr.required]="true">
              <option [ngValue]="null">-- {{ "Select" | translate }} {{ "Media" | translate }} --</option>
              <option *ngFor="let media of mediaListDropDown | sortAlpha : 'mediaTitle'" [value]="media.id">
                {{ media.mediaTitle | translate }}
              </option>
            </select>
            <label class="label-control">{{ "Media" | translate }}</label>
          </div>
        </div>
      </div>

      <div class="col-4 mt-2 mb-5">
        <div class="input-group">
          <div class="form-group w-100">
            <input class="form-control modal-text-box" type="text" formControlName="carrier" [attr.required]="true" />
            <label class="label-control">{{ "Carrier" | translate }}</label>
          </div>
        </div>
      </div>
      <div class="col-4 mt-2 mb-5">
        <div class="input-group">
          <div class="form-group w-100">
            <input class="form-control modal-text-box" type="text" formControlName="trackingnumber" [attr.required]="true" />
            <label class="label-control">{{ "Tracking Number" | translate }}</label>
          </div>
        </div>
      </div>

      <div class="col-4 mt-2 mb-5">
        <div class="input-group">
          <div class="form-group w-100">
            <select class="form-control modal-text-box" formControlName="status" [attr.required]="true">
              <option value="Vault">{{ "Vault" | translate }}</option>
              <option value="In Transit">{{ "In Transit" | translate }}</option>
              <option value="Customer">{{ "Customer" | translate }}</option>
            </select>
            <label class="label-control">{{ "Status" | translate }}</label>
          </div>
        </div>
      </div>

      <div class="col-4 mt-2 mb-5">
        <div class="input-group">
          <div class="form-group w-100">
            <input class="form-control modal-text-box" type="text" formControlName="comment" [attr.required]="true" />
            <label class="label-control">{{ "Comment" | translate }}</label>
          </div>
        </div>
      </div>

      <div class="col-4 mt-2 mb-5">
        <label class="font-roboto-cad common-label-style" style="margin-top: 30px">
          {{ "Select Shipping/Receiving" | translate }}
        </label>

        <div class="input-row mb-0">
          <div class="d-inline-block font-roboto-cad common-label-style">
            <input id="radio-2" class="radio-custom" name="radio-group" type="radio" value="Shipping" formControlName="type" />
            <label for="radio-2" class="radio-custom-label common-label-style">
              {{ "Shipping" | translate }}
            </label>
          </div>
          <div class="d-inline-block font-roboto-cad common-label-style">
            <input id="radio-1" class="radio-custom" name="radio-group" type="radio" value="Receiving" formControlName="type" />
            <label for="radio-1" class="radio-custom-label common-label-style">
              {{ "Receiving" | translate }}
            </label>
          </div>
        </div>
      </div>

      <div class="col-4 mt-2 mb-5">
        <form [formGroup]="dateForm" style="display: initial">
          <div class="input-group" style="margin-top: 30px">
            <label class="label-control d-inline font-16">{{ "Date" | translate }} : </label>
            <p-calendar
              [locale]="derivedSettings.customLocale"
              [locale]="derivedSettings.customLocale"
              class="s-right"
              appendTo="body"
              placeholder="{{ 'Due Date' | translate }}"
              formControlName="from"
              [showTime]="true"
              dateFormat="{{ derivedSettings.dateFormatCal }}"
              hourFormat="{{ derivedSettings.timeFormat }}"
              [showIcon]="false"></p-calendar>
          </div>
        </form>
      </div>
    </div>
  </form>

  <!-- <button class="delete-btn-lt" *ngIf="data.orderData != null"  (click)="deleteOrder()" ><i class="fas fa-trash-alt"></i>{{'Delete' | translate}}</button> -->
  <button class="submit-btnTop-rt" (click)="saveShipping()">{{ "Save & close" | translate }}</button>
</div>
